<template>
  <div class="w-full flex flex-col overflow-hidden">
    <loading v-if='$apollo.loading' />

    <div v-if='postTypeToCreate !== "post"' class="p-4" >
      <div class="w-full bg-gray-800 bg-no-repeat" style="
        background-blend-mode: multiply;
        background-position: center center;
        background-size: contain;
        background-image: url('/img/PBC_Ninja.svg');
      ">
        <div class="p-10 py-12 flex flex-col flex-wrap justify-center content-center">
          <div class="z-60 mt-4 auth-content-rotate">
              <h1 class="text-white font-bold text-2xl">Unleash</h1>
              <h1 class="text-white text-xl -mt-3">Your inner</h1>
              <h2 class="text-blue-300 font-bold text-2xl -mt-2">Memelord <span class="text-white font-normal">or</span> Game Ninja</h2>
          </div>
        </div>
      </div>
    </div>

    <pbc-error v-if='!!error' :error='error' :retry='true' @retry='onRetry' message='Could not load post' />

  </div>
</template>
<script>
const LONG_PATTERN = "yyyy-MM-dd'T'HH:mm:ss";
import { savePostDraftQuery } from '@/gql/Queries.js';
import { format, formatISO9075, addMinutes } from 'date-fns'
import { cloneDeep } from 'lodash';
import gql from 'graphql-tag';

const getGameQuery = gql(`
        query($id: String!) {
          getGame(id: $id)
        }
`);

export default {
  props:{
  },
  components: {
  },
  data() {
    const editingParentId = this.$route.params.parentId;
    const editingOpId = 'root';
    const draftId = formatISO9075(this.getUTCDate(), { format: 'basic' }).replace(' ', '-');
    return {
      getGame:'{}',
      getRootGame:'{}',
      editingParentId,
      editingOpId,
      getPost:{
      },
      ignoreDrafts: false,
      draftId,
      error:'',
    }
  },
  apollo: {
    getPost: {
      query:gql(`
        query getPost($id: String!) {
          getPost(id: $id) {
            title,
            id,
            game
            image
            type
            parent {
              id
            }
          }
        }
      `),
      variables() {
        return {
          id: this.editingParentId
        }
      },
      error(error) {
        this.error = JSON.stringify(error.message);
      }
    },
    getRootGame: {
      query: getGameQuery,
      variables() {
        return {
          id: 'root'
        }
      },
      update(data) {
        return data.getGame;
      },
      skip() {
        return !!this.gameId
      },
      error(error) {
        this.error = JSON.stringify(error.message);
      }
    },
    getGame: {
      query: getGameQuery,
      variables() {
        return {
          id: this.gameId
        }
      },
      skip() {
        return !this.gameId
      },
      error(error) {
        this.error = JSON.stringify(error.message);
      },
      async result({data,loading,networkStatus}) {
        console.log('i got the result', data);
        const gd = JSON.parse(data.getGame);

        if (this.$route.params.__autoRemixImage) {
          gd.__autoRemixImage = this.$route.params.__autoRemixImage;
          gd.__autoRemixTitle = this.$route.params.__autoRemixTitle;
        }
        if (this.$route.params.__autoRemixData) {
          gd.__autoRemixData = this.$route.params.__autoRemixData;
        }

        if (this.$route.params.__autoselect) {
          gd.__autoSelectFirstTransform = true;
        }


        const gamedata = JSON.stringify(gd);
        const created = format(this.getUTCDate(), LONG_PATTERN);
        const updated = format(this.getUTCDate(), LONG_PATTERN);
        const draftId = this.$route.params.draftId || formatISO9075(this.getUTCDate(), { format: 'basic' }).replace(' ', '-');
        const id = draftId;
        const title = this.getPost.id !== 'root' ? (this.getPost.title || '') : '';
        const parentId = this.editingParentId || 'root';
        let opId = 'root';
        if (this.getPost && this.getPost.parent && this.getPost.parent.id) {
          opId = this.getPost.parent.id || 'root';
        }
        console.log('have OPID', opId);
        await this.$apollo.mutate({
          mutation:savePostDraftQuery,
          //mutation:addItemQuery,
          fetchPolicy:'no-cache',
          client:'localClient',
          variables:{
            id,
            created,
            updated,
            gamedata,
            parentId,
            opId,
            title
          }
        });

        this.$router.replace({
          name:'create',
          params:{
            draftId:id,
            parentId,
            type:'post'
          }
        });


        return gd;

      }
    },

  },
  mounted() {
  },
  methods:{
    onRetry() {
      this.$apollo.queries.getPost.refetch();
      this.$apollo.queries.getRootGame.refetch();
      this.$apollo.queries.getGame.refetch();
      this.error = '';
    },
    getUTCDate() {
      const date = new Date();
      return addMinutes(date, date.getTimezoneOffset());
    },
  },
  computed:{
    postTypeToCreate() {
      return this.$route.params.type || 'post';
    },
    gameId() {
      return !this.error && this.getPost.game;
    },
    /*
    gamedata() {
      if (this.error) {
        console.error('error', this.error);
        return {};
      }
      if (this.gameId) {
      } else {
        const gamedata = JSON.parse(this.getRootGame);
        gamedata.__autoRemixImage = this.getPost.image;
        if (this.$route.params.__autoselect) {
          gamedata.__autoSelectFirstTransform = true;
        }
        return gamedata;
      }
    },
    */
  },
  watch:{
  },
}
</script>
